var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkActionFacility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96329 21V9.686C4.96329 9.384 5.19849 9.138 5.48937 9.138H7.06569C7.20505 9.138 7.33871 9.0804 7.43734 8.97785C7.53597 8.87529 7.59151 8.73616 7.59177 8.591V5.122C7.59177 4.819 7.82697 4.574 8.11785 4.574H15.8266C16.1166 4.574 16.3518 4.819 16.3518 5.122V8.59C16.3518 8.892 16.587 9.137 16.8778 9.137H18.4542C18.745 9.137 18.9802 9.383 18.9802 9.685V21.001M11.9703 4.573V3M20.1601 21H3.78345M9.82185 17.484L9.82377 17.538M9.82185 14.285L9.82377 14.339M14.2695 17.484L14.2676 17.538M14.2695 14.285L14.2676 14.339M11.9713 9.431V11.101M11.9713 9.431V7.761M11.9713 9.431H13.5735M11.9713 9.431H10.369",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkActionFacility);
export default __webpack_public_path__ + "static/media/bulk-action-facility.b3340f779c01c2d006f5dc61124b9eba.svg";
export { ForwardRef as ReactComponent };